import type { ShmpCourseNumber } from '@/types'

export function formatShmpCourse(
  courseNumbers: ShmpCourseNumber[] | null | undefined,
  fallback: ShmpCourseNumber | null
): string {
  const courses = courseNumbers?.length
    ? courseNumbers
    : fallback
      ? [fallback]
      : []

  if (courses.length === 0) return '—'
  if (courses.length === 1) return `${courses[0]} курс`
  return courses.join(' → ')
}
